import { Route } from 'vue-router';

import { Errors } from '@/enums/errors.enum';
import { systemMessageDetailsRoute } from '@/router/mainRoute/systemMessageRoute/details.route';
import store from '@/store/store';
import { tryParseInt } from './number';

export function getMessageData(to: Route, from: Route, next: any): void {
  store.commit('systemMessage/setId', tryParseInt(to.params.messageId));
  store
    .dispatch('systemMessage/get')
    .then(message => {
      systemMessageDetailsRoute.meta.breadcrumb.title = message.name;
      next();
    })
    .catch(err => store.dispatch('notifyError', { title: Errors.SYSTEM_MESSAGE_CANNOT_GET }));
}
